import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'galaxy.main-menu.collapsed';

@Injectable({ providedIn: 'root' })
export class MainMenuStateService {
  private readonly collapsedSignal = signal<boolean>(this.read());
  readonly collapsed = this.collapsedSignal.asReadonly();

  toggle(): void {
    this.set(!this.collapsedSignal());
  }

  set(value: boolean): void {
    this.collapsedSignal.set(value);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch {
      /* storage unavailable (e.g. private browsing quota) — ignore */
    }
  }

  private read(): boolean {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw === null ? true : JSON.parse(raw) === true;
    } catch {
      return true;
    }
  }
}
